import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import pure from "purecss";
// import "amfe-flexible";
import jsbridge from "./utils/jsbridge";
import VConsole from "vconsole";
import { Popup } from "vant";
import { Form } from 'vant';
import { Field } from 'vant';
import { Image as VanImage } from "vant";
import { Button } from 'vant';

Vue.config.productionTip = false;
jsbridge.initJsbridge();
// eslint-disable-next-line no-unused-vars
const vconsole = new VConsole();
window.vConsole = vconsole;

Vue.use(pure);
Vue.use(Popup);
Vue.use(VanImage);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
